export type BrowserKey =
  | "chrome-desktop"
  | "safari-mac"
  | "chrome-android"
  | "chrome-ios"
  | "safari-ios"
  | "firefox"
  | "unknown";

export const BrowserLabel: Record<BrowserKey, string> = {
    "chrome-desktop": "Chrome (Desktop)",
    "safari-mac": "Safari (macOS)",
    "chrome-android": "Chrome (Android)",
    "chrome-ios": "Chrome (iOS)",
    "safari-ios": "Safari (iOS)",
    "firefox": "Firefox",
    "unknown": "",
};

export function detectBrowser(): BrowserKey {
  const ua = navigator.userAgent;

  // Android
  if (/Android/i.test(ua) && /Chrome/i.test(ua)) return "chrome-android";

  // iOS Chrome
  if (/iPhone|iPad|iPod/i.test(ua) && /CriOS/i.test(ua)) return "chrome-ios";

  // iOS Safari
  if (/iPhone|iPad|iPod/i.test(ua) && /Safari/i.test(ua) && !/CriOS/i.test(ua))
    return "safari-ios";

  // macOS Safari
  if (/Macintosh/i.test(ua) && /Safari/i.test(ua) && !/Chrome/i.test(ua))
    return "safari-mac";

  // Chrome desktop
  if (/Chrome/i.test(ua) && !/Edg/i.test(ua) && !/OPR/i.test(ua))
    return "chrome-desktop";

  // Firefox
  if (/Firefox/i.test(ua)) return "firefox";

  return "unknown";
}
